// in seconds
export const DISCUSSIONS_POSTS_POLLING_INTERVAL = 60;
